/* eslint-disable no-new */
import FlickityImagesLoaded from 'flickity-imagesloaded';
import poll from '@/utilities/poll';

const carousels = Array.from(document.querySelectorAll('.js-product-carousel'));

const reset = (carousel) => {
    carousel.resize();
    carousel.reposition();
};

const setMinHeight = (cards) => {
    const tallest = cards.reduce((acc, current) => {
        return current.offsetHeight > acc ? current.offsetHeight : acc;
    }, 0);
    cards.forEach((card) => (card.style.minHeight = `${tallest}px`));
};

const setMinHeightFeatures = (carousel) => {
    const featureWrappers = Array.from(carousel.querySelectorAll('.CardProduct__features-wrap'));
    const minHeight = featureWrappers.reduce((acc, current) => {
        return current.offsetHeight > acc ? current.offsetHeight : acc;
    }, 0);
    featureWrappers.forEach((item) => (item.style.minHeight = `${minHeight}px`));
};

const toggleAllCards = (carousel) => {
    const action = carousel.classList.contains('toggled') ? 'remove' : 'add';
    const els = Array.from(carousel.querySelectorAll('.js-toggle-sync'));
    [carousel, ...els].forEach((item) => {
        item.classList[action]('toggled');

        if (item.getAttribute('aria-hidden')) {
            item.ariaHidden = action === 'add' ? 'false' : 'true';
        }
    });
};

carousels.forEach((carousel) => {
    const flkty = new FlickityImagesLoaded(carousel, {
        prevNextButtons: false,
        lazyLoad: 2,
        imagesLoaded: true,
        adaptiveHeight: false,
        accessibility: false,
        cellAlign: 'left',
        contain: true
    });

    // const prev = carousel.parentElement.querySelector('.prev');
    // const next = carousel.parentElement.querySelector('.next');
    // if (next && prev) {
    //     prev.addEventListener('click', () => flkty.previous());
    //     next.addEventListener('click', () => flkty.next());
    // }
    const setAria = () => {
        const cards = Array.from(carousel.querySelectorAll('[aria-hidden="true"]'));
        cards.forEach((card) => card.setAttribute('aria-hidden', false));
    };

    flkty.on('change', () => setAria());

    const cards = Array.from(carousel.querySelectorAll('.CardProduct'));
    const expandButtons = Array.from(carousel.querySelectorAll('.js-product-carousel-toggle'));
    const ctaButtons = Array.from(carousel.querySelectorAll('.js-product-button'));

    const mount = () => {
        poll(() => {
            reset(flkty);
            setMinHeight(cards);
            setMinHeightFeatures(carousel);
            setAria();
        }, 2000);
    };

    window.addEventListener('resize', mount);
    document.body.addEventListener('reset-product-carousel', mount);

    expandButtons.forEach((button) => {
        button.addEventListener('click', () => {
            toggleAllCards(carousel);
            poll(() => reset(flkty), 1500);
        });
    });
    // Follow tab interactins for accessiblity
    ctaButtons.forEach((button) => {
        button.addEventListener('focus', () => {
            const slideIndex = Number(button.closest('.Carousel__slide-full-h').dataset.slideIndex);
            flkty.select(slideIndex - 1);
        });
    });

    mount();
});
